import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/responsive/index.css';
import './styles/main.css'; // Design tokens - colors, spacing, typography, z-index, animations
import App from './App.js';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { store, persistor } from './redux/store';
import setupGlobalErrorHandlers from './utils/setupGlobalErrorHandlers.js';
import { initSentry } from './sentry.js';

// Initialize Sentry first (before any errors can occur)
initSentry();

const LoadingScreen = () => (
  <div style={{
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100dvh',
    width: '100%',
    backgroundColor: '#f8fafc'
  }}>
    <div className="loading-spinner">
      {/* You can add a loading spinner here if desired */}
    </div>
  </div>
);

// Install global error handlers early
setupGlobalErrorHandlers();

const root = ReactDOM.createRoot(document.getElementById('root'));
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 90_000,
      gcTime: 5 * 60_000,
      refetchOnWindowFocus: false,
    },
  },
});
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={<LoadingScreen />} persistor={persistor}>
        <QueryClientProvider client={queryClient}>
          <App />
        </QueryClientProvider>
      </PersistGate>
    </Provider>
  </React.StrictMode>
);

reportWebVitals();
